<script lang="ts">
import { format } from 'date-fns';
import { useFilterStub } from './filter-stub';
import { LocalFilterModel } from './FilterDateTime.vue';

// convert UTC ISO string to local datetime-local format (YYYY-MM-DDTHH:mm)
// this ensures filter comparisons use the same timezone as the displayed values
function toLocalDateTimeString(utcValue: string): string {
  const date = new Date(utcValue);
  if (isNaN(date.getTime())) return utcValue;

  return format(date, "yyyy-MM-dd'T'HH:mm");
}
</script>

<script setup lang="ts">
defineExpose(
  useFilterStub<string, LocalFilterModel>(
    {
      dateFrom: null,
      dateTo: null,
      type: 'equals',
    },
    ({ dateFrom }) => dateFrom !== null,
    ({ dateFrom, dateTo, type }, value = '') => {
      if (dateFrom === null) return true;

      const localValue = toLocalDateTimeString(value);
      const compareValue =
        dateFrom.length === 5
          ? /* time in format HH:mm */ localValue.slice(11, 16)
          : localValue.slice(0, dateFrom.length);

      switch (type) {
        case 'equals':
          return compareValue === dateFrom;
        case 'greaterThanOrEqual':
          return compareValue >= dateFrom;
        case 'lessThanOrEqual':
          return compareValue <= dateFrom;
        case 'inRange':
          return compareValue >= dateFrom && (dateTo === null || compareValue <= dateTo);
      }
    }
  )
);
</script>

<!-- eslint-disable-next-line vue/valid-template-root -->
<template></template>
